export default __webpack_public_path__ + "static/media/REFIN_affrescati_LP_CONF_OMBRA-120X120.4b808194.jpg";